var app = globalThis;
globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};

appCustomerSpace.ModalOneSpecificThematic = (function(superClass) {
  utils.extend(ModalOneSpecificThematic, superClass);

  function ModalOneSpecificThematic() {
    return ModalOneSpecificThematic.__super__.constructor.apply(this, arguments);
  }

  ModalOneSpecificThematic.prototype.init = function() {
    return ModalOneSpecificThematic.__super__.init.apply(this, arguments);
  };

  ModalOneSpecificThematic.prototype.callbackSuccess = function(data, successMsg) {
    if (data.response && this.$html.data('target')) {
      $container = $(this.$html.data('target'));

      if(app.currentModalOpener && app.currentModalOpener.$html.closest('.library-item').length) {
        app.currentModalOpener.$html.closest('.library-item').replaceWith(data.html);
      } else {
        $container.append(data.html);
      }

      appCustomerSpace.creationForm.currentStep.handleItemArrows($container);
      appCustomerSpace.LimitlessPlugins.initPlugins($container);

      $('body').trigger('job_form.change', [$container.parent()]);
    }

    return ModalOneSpecificThematic.__super__.callbackSuccess.call(this, data);
  };

  return ModalOneSpecificThematic;

})(appCustomerSpace.ModalCreationFormSubmissionFunnel);
